import {
  ComponentPropsOptions,
  defineComponent,
  h
} from '@vue/composition-api';
import { SmoothStepEdgeProps } from '../../types';
import { Position } from '../../types';
import BaseEdge from './BaseEdge.vue';
import { getSmoothStepPath } from './utils';

const SmoothStepEdge = defineComponent<SmoothStepEdgeProps>({
  name: 'SmoothStepEdge',
  props: [
    'sourcePosition',
    'targetPosition',
    'label',
    'labelStyle',
    'labelShowBg',
    'labelBgStyle',
    'labelBgPadding',
    'labelBgBorderRadius',
    'sourceY',
    'sourceX',
    'targetX',
    'targetY',
    'borderRadius',
    'markerEnd',
    'markerStart',
    'interactionWidth',
    'offset',
    'data'
  ] as ComponentPropsOptions<SmoothStepEdgeProps>,

  setup(props, { attrs }) {
    return () => {
      const [path, labelX, labelY] = getSmoothStepPath({
        ...props,
        sourcePosition: props.sourcePosition ?? Position.Bottom,
        targetPosition: props.targetPosition ?? Position.Top
      });

      return h(BaseEdge, {
        attrs: {
          path,
          labelX,
          labelY,
          ...attrs
        },
        props: props
      });
    };
  }
});

export default SmoothStepEdge;
